import { OperationSmvModel } from "./operation-smv.model";

export class StyleSmvModel {
    style: string;
    garmentSmv: number;
    operationSmv: OperationSmvModel[];

    constructor(style: string, garmentSmv: number, operationSmv: OperationSmvModel[]) {
        this.style = style;
        this.garmentSmv = garmentSmv;
        this.operationSmv = operationSmv;
    }
}

